import { render } from "./Gallery.vue?vue&type=template&id=a0f0e0b6&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=a0f0e0b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a0f0e0b6"

export default script